import { render, staticRenderFns } from "./InsolvencyPreview.vue?vue&type=template&id=a2cd9d0c&scoped=true&"
import script from "./InsolvencyPreview.vue?vue&type=script&lang=js&"
export * from "./InsolvencyPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cd9d0c",
  null
  
)

export default component.exports